/**
 * Created by henian.xu on 2022/11/10.
 *
 */

import { get } from 'vmf';

function demoGetBASE64(dataArray) {
    const digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let strData = '';
    for (let i = 0, ii = dataArray.length; i < ii; i += 3) {
        if (Number.isNaN(dataArray[i])) break;
        const b1 = dataArray[i] & 0xff;
        const b2 = dataArray[i + 1] & 0xff;
        const b3 = dataArray[i + 2] & 0xff;
        const d1 = b1 >> 2;
        const d2 = ((b1 & 3) << 4) | (b2 >> 4);
        const d3 = i + 1 < ii ? ((b2 & 0xf) << 2) | (b3 >> 6) : 64;
        const d4 = i + 2 < ii ? b3 & 0x3f : 64;
        strData +=
            digits.substring(d1, d1 + 1) +
            digits.substring(d2, d2 + 1) +
            digits.substring(d3, d3 + 1) +
            digits.substring(d4, d4 + 1);
    }
    return strData;
}
export async function downloadPDF(url, params = {}) {
    const res = await get(url, params, {
        isHandleError: true,
        responseType: 'arraybuffer',
    });
    const dataArray = new Uint8Array(res.data);
    return demoGetBASE64(dataArray);
}
